import { render, staticRenderFns } from "./reportMS.vue?vue&type=template&id=39520214&scoped=true&"
import script from "./reportMS.vue?vue&type=script&lang=js&"
export * from "./reportMS.vue?vue&type=script&lang=js&"
import style0 from "./reportMS.vue?vue&type=style&index=0&id=39520214&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39520214",
  null
  
)

export default component.exports